import { frontendURL } from '../../../helper/URLHelper';

const FacebookAutomationIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/facebook-automation'),
      name: 'facebook_automation_index',
      component: FacebookAutomationIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
